module.exports = __webpack_public_path__ + "static/media/dislikeHover.857d08f8.svg";